import createActionType from "../../utils/createActionType";

export const MODULE = "delivery-scheduling/sort-filter";

export const SET_SELECTED_SORTING_OPTION = createActionType(MODULE, "setSelectedSortingOption");

export const RESET = createActionType(MODULE, "reset");
